import { Search, ShieldCheck } from "lucide-react";
import { useMemo, useState } from "react";
import { AssetCard } from "../components/AssetCard";
import { EmptyState } from "../components/EmptyState";
import { FilterChips } from "../components/FilterChips";
import { LastUpdated } from "../components/LastUpdated";
import { PageHeader } from "../components/PageHeader";
import { assetCategories } from "../data/categories";
import { brandAssets } from "../data/brandAssets";
import { normalizeSearch } from "../lib/search";

const statusOptions = [
  { id: "all", label: "Все статусы" },
  { id: "current", label: "Актуальная версия" },
  { id: "needs-review", label: "Требует проверки" },
  { id: "archived", label: "Архив" },
];

export function AssetsPage() {
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("all");
  const [status, setStatus] = useState("all");
  const [language, setLanguage] = useState("all");

  const assets = useMemo(() => {
    const needle = normalizeSearch(query);
    return brandAssets.filter((asset) => (
      (!needle || normalizeSearch(`${asset.title} ${asset.description ?? ""} ${asset.fileType} ${asset.tags.join(" ")}`).includes(needle))
      && (category === "all" || asset.category === category)
      && (status === "all" || asset.status === status)
      && (language === "all" || asset.language === language || asset.language === "multi")
    ));
  }, [query, category, status, language]);

  return (
    <div className="page">
      <PageHeader
        eyebrow="Раздел 04"
        title="Логотипы, брендбуки и файлы"
        description="Визуальный каталог актуальных материалов и правил их использования."
      />
      <LastUpdated date="2026-07-28" section />

      <div className="asset-hero">
        <div>
          <ShieldCheck size={24} aria-hidden="true" />
          <div><strong>Используйте только актуальные версии</strong><span>Сверяйте статус и правила на карточке каждого файла.</span></div>
        </div>
        <span>{brandAssets.filter((asset) => asset.status === "current").length} актуальных материалов</span>
      </div>

      <section className="filters-panel" aria-label="Фильтры файлов">
        <div className="filters-panel__search">
          <Search size={19} aria-hidden="true" />
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Найти логотип или файл" aria-label="Найти логотип или файл" />
        </div>
        <FilterChips
          label="Категория файла"
          value={category}
          onChange={setCategory}
          options={[{ id: "all", label: "Все материалы" }, ...assetCategories]}
        />
        <div className="filter-row filter-row--two">
          <label>
            <span>Статус</span>
            <select value={status} onChange={(event) => setStatus(event.target.value)}>
              {statusOptions.map((item) => <option key={item.id} value={item.id}>{item.label}</option>)}
            </select>
          </label>
          <label>
            <span>Язык</span>
            <select value={language} onChange={(event) => setLanguage(event.target.value)}>
              <option value="all">Все языки</option>
              <option value="ru">Русский</option>
              <option value="uz">O‘zbekcha</option>
              <option value="en">English</option>
            </select>
          </label>
        </div>
      </section>

      <div className="assets-grid">
        {assets.map((asset) => <AssetCard key={asset.id} asset={asset} />)}
      </div>
      {assets.length === 0 && <EmptyState description="В выбранной категории пока нет файлов." />}
    </div>
  );
}
